<template>
  <div id="maintenancePartsList" class="product-list maintenance-parts-list">
    <MaintenancePartsCard
      v-for="(productObj) in products"
      :key="productObj.id"
      :product="productObj"
    />
  </div>
</template>

<script>
import MaintenancePartsCard from '@/components/MaintenancePartsCard.vue'

export default {
  name: 'MaintenancePartsSearchResults',
  components: {
    MaintenancePartsCard
  },
  props: {
    products: Array
  }
}
</script>
